import React from 'react';
import axios from 'axios';
import {Route, Switch, withRouter} from "react-router-dom";
import {connect} from "react-redux";

import SpecialList from "./SpecialList";
import SpecialForm from "./SpecialForm";
import SpecialPreview from "./SpecialPreview";
import VideoForm from "./VideoForm";
import SpecialImageForm from "./SpecialImageForm";
import * as NotificationsActionCreators from "../../redux/actions/notificationsActions";

import './style.css'

class Specials extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            size: {
                width: 200,
                height: 200
            }
        };

        this.handleAddSpecial = this.handleAddSpecial.bind(this);
        this.handleEditSpecial = this.handleEditSpecial.bind(this);
        this.handleChangeEnabled = this.handleChangeEnabled.bind(this);
        this.handleAddSpecialImage = this.handleAddSpecialImage.bind(this);
        this.handleRemoveSpecial = this.handleRemoveSpecial.bind(this);
    }

    handleAddSpecial(values) {
        let loginToken = this.props.sessionData.accessToken;
        let config = {
            headers: {
                'Authorization': 'Bearer ' + loginToken
            }
        };
        axios.post(this.props.api.specials, {
            ...values,
        }, config).then((response) => {
            this.props.addNotification('success', response.status, 'Speciál ' + response.data.name + ' byl vytvořen.');
            this.props.history.push('/specials');
        }).catch((error) => {
            this.props.addNotification('error', error.response.status, error.response.data.message ? error.response.data.message : 'Speciál se nepodařilo vytvořit!');
            this.props.history.push('/specials');
            console.log("Axios error: ", error);
        });
    }

    handleChangeEnabled(special){
        let loginToken = this.props.sessionData.accessToken;
        let config = {
            headers: {
                'Authorization': 'Bearer ' + loginToken
            }
        };

        // kontrola videí - nesmí jít povolit pokud nemá videa
        let questionsVideos = special.questions.map((question) => question.videos ? question.videos.length : 0);
        let enabled = !special.enabled;

        if (enabled && questionsVideos.indexOf(0) !== -1) {
            enabled = false;
        }

        axios.put(this.props.api.specials + "/" + special.id, {
            enabled
        }, config).then((response) => {
            if (!special.enabled && questionsVideos.indexOf(0) === -1) {
                this.props.addNotification('success', response.status, 'Speciál ' + special.name + ' byl povolen.');
            } else if (!special.enabled && questionsVideos.indexOf(0) !== -1) {
                this.props.addNotification('warning', null, 'Speciál ' + special.name + ' nemohl být povolen. Chybí video u některé z otázek.');
            } else {
                this.props.addNotification('success', response.status, 'Speciál ' + special.name + ' byl zakázán.');
            }
        }).catch((error) => {
            this.props.addNotification('error', error.response.status, error.response.data.message ? error.response.data.message : 'Speciál se nepodařilo '+(enabled ? 'povolit' :  'zakázat')+'!');
            console.log("Axios error: ", error);
        })
    }

    handleEditSpecial(values) {
        let loginToken = this.props.sessionData.accessToken;
        let config = {
            headers: {
                'Authorization': 'Bearer ' + loginToken
            }
        };
        axios.put(this.props.api.specials + "/" + values.id, {
            ...values,
        }, config).then((response) => {
            this.props.addNotification('success', response.status, 'Speciál ' + response.data.name + ' byl upraven.');
            this.props.history.push('/specials');
        }).catch((error) => {
            this.props.addNotification('error', error.response.status, error.response.data.message ? error.response.data.message : 'Speciál se nepodařilo upravit!');
            this.props.history.push('/specials');
            console.log("Axios error: ", error);
        });
    }

    handleAddSpecialImage(values) {
        let loginToken = this.props.sessionData.accessToken;
        let config = {
            headers: {
                'Authorization': 'Bearer ' + loginToken
            }
        };
        axios.put(this.props.api.specials + "/" + values.id, {
            specialBase64: values.specialBase64,
        }, config)
        .then((response) => {
            this.props.addNotification('success', response.status, 'Obrázek speciálu ' + response.data.name + ' byl upraven.');
            this.props.history.push('/specials');
        })
        .catch((error) => {
            this.props.addNotification('error', error.response.status, error.response.data.message ? error.response.data.message : 'Obrázek speciálu se nepodařilo upravit!');
            this.props.history.push('/specials');
            console.log("Axios error: ", error);
        })
    }

    handleRemoveSpecial(special) {
        let loginToken = this.props.sessionData.accessToken;
        let config = {
            headers: {
                'Authorization': 'Bearer ' + loginToken
            }
        };
        axios.delete(this.props.api.specials + "/" + special.id, config).then((response) => {
            this.props.addNotification('success', response.status, 'Speciál ' + special.name + ' byl odstraněn.');
        }).catch((error) => {
            this.props.addNotification('error', error.response.status, error.response.data.message ? error.response.data.message : 'Speciál se nepodařilo odstranit!');
            console.log("Axios error: ", error);
        });
    }

    render() {
        return (
            <div id="page-specials" className="right-col" role="main">
                <div className="page-title">
                    <div className="title-left">
                        <h3>Speciály</h3>
                    </div>
                </div>
                <Switch>
                    <Route exact path="/specials" component={() =>
                            <SpecialList
                                {...this.props}
                                handleChangeEnabled={this.handleChangeEnabled}
                                handleRemoveSpecial={this.handleRemoveSpecial}
                            />
                    }
                    />
                    <Route path="/specials/preview/:id" component={() =>
                            <SpecialPreview
                                {...this.props}
                            />
                    }
                    />
                    <Route path="/specials/add" component={() =>
                            <SpecialForm
                                {...this.props}
                                title="Přidání speciálu"
                                button="Přidat"
                                action={this.handleAddSpecial}
                            />
                    }
                    />
                    <Route path="/specials/edit/:id" component={() =>
                        <SpecialForm
                            {...this.props}
                            title="Úprava speciálu"
                            button="Upravit"
                            action={this.handleEditSpecial}
                        />
                    }
                    />
                    <Route path="/specials/image/:id" component={() =>
                        <SpecialImageForm
                            {...this.props}
                            title="Přidání obrázku ke speciálu"
                            button="Uložit"
                            size={this.state.size}
                            action={this.handleAddSpecialImage}
                        />
                    }
                    />
                    <Route path="/specials/video/:id" component={() =>
                        <VideoForm
                            {...this.props}
                        />
                    }
                    />
                </Switch>
            </div>
        );
    }
}

const mapStateToProps = function(state){
    return {
        notifications: state.notifications,
    }
};

const mapDispatchToProps = function (dispatch) {
    return {
        addNotification: (type, status, message) => dispatch(NotificationsActionCreators.addNotification(type, status, message)),
    }
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Specials));



/** WEBPACK FOOTER **
 ** ./src/containers/Specials/index.js
 **/